import { SpeechBubbleFill24Icon } from "@vygruppen/spor-icon-react";
import { FC } from "react";
import { HStack } from "shared/components/Spor";
import { TextTooltip } from "shared/components/TextTooltip";

type CodeAndCommentProps = {
  code: string | null;
  comment: string | null;
};

const CodeAndComment: FC<CodeAndCommentProps> = ({ code, comment }) => (
  <HStack>
    <p>{code}</p>
    {comment?.replace(/^\s*$/, "")?.length && (
      <TextTooltip showArrow label={comment} placement="top">
        <SpeechBubbleFill24Icon aria-label="Kommentar" />
      </TextTooltip>
    )}
  </HStack>
);

export default CodeAndComment;
